import { ref } from 'vue';
import { defineStore } from 'pinia';

/**
 * Store für ContentModeWrapper Lifecycle State
 *
 * Trackt ob ContentModeWrapper aktuell gemountet ist
 * Sent Inter-Window Signals via BroadcastChannel
 * Speichert auch zu localStorage für Cross-Tab Sync
 */

// Global BroadcastChannel for cross-window communication
let contentModeChannel: BroadcastChannel | null = null;

function getChannel(): BroadcastChannel {
  if (!contentModeChannel) {
    contentModeChannel = new BroadcastChannel('contentmode-lifecycle');
  }
  return contentModeChannel;
}

export const useContentModeStateStore = defineStore('contentmodestate', () => {
  // True when ContentModeWrapper is currently in DOM
  const isContentModeWrapperMounted = ref(false);

  function setWrapperMounted(mounted: boolean) {
    isContentModeWrapperMounted.value = mounted;

    // Sende Signal an externe Fenster via BroadcastChannel
    try {
      const channel = getChannel();
      const message = {
        type: 'WRAPPER_LIFECYCLE_CHANGED',
        mounted,
        timestamp: Date.now(),
      };
      channel.postMessage(message);
    } catch (error) {
      console.warn('[ContentModeState] BroadcastChannel error:', error);
    }

    // Also save to localStorage so external windows can react immediately
    try {
      const data = {
        mounted,
        timestamp: Date.now(),
      };
      localStorage.setItem('contentmode-wrapper-mounted', JSON.stringify(data));
    } catch (error) {
      console.warn('[ContentModeState] localStorage error:', error);
    }
  }

  // Save the main window's current route for external windows
  function setCurrentContentRoute(path: string, query: Record<string, any> = {}) {
    try {
      const routeData = {
        path,
        query,
        timestamp: Date.now(),
      };
      localStorage.setItem('contentmode-current-route', JSON.stringify(routeData));
    } catch (error) {
      console.warn('[ContentModeState] Error storing current route:', error);
    }
  }

  return {
    isContentModeWrapperMounted,
    setWrapperMounted,
    setCurrentContentRoute,
    getChannel,
  };
});
